import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ArtifactRenderer } from '../artifacts/ArtifactRenderer';
import { normalizeMarkdownTables } from '@/utils/markdown';
import type { Artifact } from '@/types';

interface StreamingMessageProps {
  content: string;
  artifacts: Artifact[];
  thinkingStatus?: string | null;
}

export function StreamingMessage({ content, artifacts, thinkingStatus }: StreamingMessageProps) {
  return (
    <div className="flex items-end gap-2 py-1.5">
      <video
        src="/zac-avatar.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="h-9 w-9 shrink-0 rounded-lg object-cover"
        aria-label="ZAC"
      />
      <div className="max-w-[85%] rounded-tl-2xl rounded-tr-2xl rounded-br-2xl rounded-bl-sm bg-white/[0.04] px-4 py-3 text-foreground">
        {thinkingStatus && !content && (
          <div className="flex items-center gap-2 text-xs text-muted-foreground mb-2">
            <ThinkingDots />
            <span>{thinkingStatus}</span>
          </div>
        )}
        <div className="prose dark:prose-invert max-w-none text-foreground">
          {content ? (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {normalizeMarkdownTables(content)}
            </ReactMarkdown>
          ) : !thinkingStatus ? (
            <div className="flex items-center gap-2 text-muted-foreground">
              <ThinkingDots />
            </div>
          ) : null}
        </div>

        {artifacts.length > 0 && (
          <div className="mt-4 space-y-4">
            {artifacts.map((artifact) => (
              <ArtifactRenderer key={artifact.id} artifact={artifact} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function ThinkingDots() {
  return (
    <div className="flex gap-1">
      <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground [animation-delay:-0.3s]" />
      <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground [animation-delay:-0.15s]" />
      <span className="h-2 w-2 animate-bounce rounded-full bg-muted-foreground" />
    </div>
  );
}
